"use client";

import TeamTopSection from "@/components/frontend/team/TeamTopSection";
import TeamMembers from "@/components/frontend/team/TeamMembers";
import PremiumTeam from "@/components/frontend/team/PremiumTeam";


export default function People() {

  return (
    <div className="flex flex-col items-center justify-center w-full">

      {/* TOP SECTION */}
      <TeamTopSection />

      {/* TEAM SECTION */}
      <TeamMembers />
      {/* <PremiumTeam /> */}

      {/* join our team */}
      <div className="flex w-full items-start justify-center h-[300px] relative"
      style={{backgroundImage:"url('/images/map.png')", backgroundRepeat:"no-repeat", backgroundSize:"cover", backgroundPosition:"center center", backgroundAttachment: "fixed"}}>

        {/* overlay */}
        <div className="flex bg-secondary/90 inset-0 absolute"/>

        <div className="flex flex-col items-center justify-center w-full h-full gap-6 z-10">
          <h2 className="text-[56px] font-semibold leading-15 text-primary">Join us today!</h2>
          <button className="bg-primary text-white px-4 py-3 text-[18px]">Explore available vacancies</button>
        </div>

      </div>

    </div>
  );
}
